const IDLE_TIMEOUT = 5 * 60 * 1000; // 5 minutes

let lastActivityTime = Date.now();

function checkActivity() {
  const currentTime = Date.now();
  const timeElapsed = currentTime - lastActivityTime;
  const isTimedOut = timeElapsed > IDLE_TIMEOUT;
  if (isTimedOut) {
    console.log("Reloading page due to inactivity");
    location.reload();
  }
}

function resetActivityTimer() {
  lastActivityTime = Date.now();
}

document.addEventListener("click", resetActivityTimer);
document.addEventListener("mousemove", resetActivityTimer);
document.addEventListener("scroll", resetActivityTimer);
document.addEventListener("touchstart", resetActivityTimer);

// Check for idle when page becomes visible.
function reloadOnReturnFromIdle() {
  document.addEventListener("visibilitychange", () =>
    (document.visibilityState === "visible") && checkActivity()
  );
}

export { reloadOnReturnFromIdle };
